export default __webpack_public_path__ + "static/media/Monk's Bracers of the Hallow Worlds.d8092758.jpg";